<template>
  <div class="ui-button" :class="[`color-${colorType}`, { 'hook': hook } ]" @click="$emit('click', $event)">
    <div class="inner-box">
      <slot></slot>
    </div>
  </div>
</template>

<script setup>
// colorType 不传则输出纯净按钮(只有 slot 内容, 无 bg / 边框 / 阴影), 用于自定义外观场景
// 常用: blue / blue-light / green / red / red-complex / yellow / white / white-all / gold
defineOptions({ name: 'UiButton' })

defineEmits(['click'])

defineProps({
  colorType: {
    type: String,
    default: ''
  },
  hook: {
    type: Boolean,
    default: false
  }
})
</script>

<style lang="scss" scoped>
.ui-button {
  position: relative;
  width: 100%;
  height: 100%;
  .inner-box {
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &.color-gold .inner-box {
    background: url(https://website.xdcdn.net/poster/58881/26match/common/P9iqSuwd.png) center/contain no-repeat;
    filter: drop-shadow(0 4px 4px rgba(#000, 25%));
    :deep(.label-box) {
      .label-shadow {
        color: rgba(#000000, 70%);
      }
      .label-text {
        color: #FFFFFF;
      }
    }
  }
  &.color-red .inner-box {
    background: url(https://website.xdcdn.net/poster/58881/26match/common/P9irbytq.png) center/contain no-repeat;
    filter: drop-shadow(0 4px 4px rgba(#000, 25%));
    :deep(.label-box) {
      .label-shadow {
        color: rgba(#000000, 70%);
      }
      .label-text {
        color: #FFFFFF;
      }
    }
  }
  &.color-red-complex .inner-box {
    background: url(https://website.xdcdn.net/poster/58881/26match/common/P842fgpx.png) center/contain no-repeat;
    :deep(.label-box) {
      .label-shadow {
        color: #A31813;
      }
      .label-text {
        color: #FFFFFF;
      }
    }
  }
  &.color-blue .inner-box {
    background-color: #0D459E;
    border: get_vh(2) solid #193767;
    box-shadow: 0px get_vh(2) 0px get_vh(1) #3E75CB inset;
    :deep(.label-box) {
      .label-shadow {
        color: #133469;
      }
      .label-text {
        color: #fff;
      }
    }
  }
  &.color-blue-light .inner-box {
    background-color: #4572BA;
    border: get_vh(2) solid #134295;
    box-shadow: 0px get_vh(2) 0px get_vh(1) #759CDB inset;
    :deep(.label-box) {
      .label-shadow {
        color: #244B89;
      }
      .label-text {
        color: #fff;
      }
    }
  }
  &.color-green .inner-box {
    background-color: #29CA6A;
    border: get_vh(2) solid #109345;
    box-shadow: 0px get_vh(2) 0px get_vh(1) #45E987 inset;
    :deep(.label-box) {
      .label-shadow {
        color: #12A74E;
      }
      .label-text {
        color: #fff;
      }
    }
  }
  &.color-yellow .inner-box {
    background-color: #FEE000;
    border: get_vh(2) solid #7B5218;
    box-shadow: 0px get_vh(2) 0px get_vh(1) #FFF799 inset;
    .label-box {
      .label-shadow {
        color: #FFFAC1;
      }
      .label-text {
        color: #513718;
      }
    }
  }
  &.color-white .inner-box {
    background-color: #D8D8D8;
    border: get_vh(2) solid #ACACAC;
    box-shadow: 0px get_vh(2) 0px get_vh(1) #FFFFFF inset;
    :deep(.label-box) {
      .label-shadow {
        color: #FFFFFF;
      }
      .label-text {
        color: #616161;
      }
    }
  }
  &.color-white-all .inner-box {
    background-color: #FFFFFF;
    border: get_vh(2) solid #FFFFFF;
    box-shadow: 0px 0 0px get_vh(2) #CCCCCC inset;
    :deep(.label-box) {
      .label-shadow {
        color: transparent;
      }
      .label-text {
        color: #333333;
      }
    }
  }
}
</style>
